import {Nullable} from 'app/interface';

/**
 * If passed location's hash looks like an id, return it in [id="${...}"] form.
 * Otherwise, return null.
 * @param hash
 */
export function getSelectorFromHash(hash: string): Nullable<string> {
    const match = hash.match(/^#([0-9a-z_-]+)$/i);

    if (!match) {
        return null;
    }

    return `[id="${match[1]}"]`;
}

export function getCidSelectorFromHash(hash: string): Nullable<string> {
    const match = hash.match(/^#\/([0-9a-z_-]+)\//i);

    if (Array.isArray(match) && match.length === 2) {
        return `[data-cid="${match[1]}"]`;
    }

    return null;
}
